(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
class CartRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('cart-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            // if ( (html.querySelector('.grid__item'))&&($jq(window).width() < 426) ) {
            //   this.classList.add('product-recommendations--loaded');
            //   $jq('.recommendations__grid').slick({
            //   dots: true,
            //   infinite: true,
            //   speed: 500,
            //   centerMode: true,
            //   slidesToShow: 1,
            //   variableWidth: false,
            //   prevArrow: $jq('.custom__arrow-left'),
            //   nextArrow: $jq('.custom__arrow-right'),
            //   customPaging : function(slider, i) {
            //   return '<div class="recommendations-slide-dot">&nbsp;</div>';
            //   },
            //   mobileFirst: true,
            //   responsive: [
            //   {
            //   breakpoint: 500,
            //   settings: {
            //   slidesToShow: 1
            //   }
            //   },
            //   {
            //   breakpoint: 750,
            //   settings: "unslick"
            //   }
            //   ]
            //   });
            // }

            this.interval = setInterval(() => {
              if(!yotpo) return;

              yotpo.initWidgets();
              clearInterval(this.interval);
            }, 50);
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featured-prods"] && !window.DesignMode) return;
  try {
    
  if (typeof $jq === 'undefined') {
    var $jq = jQuery.noConflict();
  }	

  document.addEventListener("DOMContentLoaded", () => {
    // Find all featured product sliders on the page
    const sliders = document.querySelectorAll('.js-custom__featured-slider');
    
    sliders.forEach(slider => {
      const sectionId = slider.closest('[data-section-id]').dataset.sectionId;
      const sliderElement = $jq(`#shopify-section-${sectionId} .js-custom__featured-slider`);
      
      // Check if slider is already initialized
      if (!sliderElement.hasClass('slick-initialized')) {
        sliderElement.slick({
          dots: true,
          infinite: true,
          speed: 500,
          centerMode: true,
          slidesToShow: 1,
          arrows: true,
          variableWidth: true,
          prevArrow: $jq(`#shopify-section-${sectionId} .custom__arrow-left-feat-prods`),
          nextArrow: $jq(`#shopify-section-${sectionId} .custom__arrow-right-feat-prods`),
          customPaging: function(slider, i) {
            return '<div class="recommendations-slide-dot">&nbsp;</div>';
          },
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 4,
                variableWidth: false,
                centerMode: false
              }
            }
          ]
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (e) => {
    window.addEventListener('orientationchange', (e) => {
      if(screen.width >= 990) {
        document.querySelector('body').style.removeProperty('overflow-y');
        document.querySelector('body').style.removeProperty('height');
      }
    });
    window.addEventListener('resize', (e)=> {
      if(screen.width >= 990) {
        document.querySelector('body').style.removeProperty('overflow-y');
        document.querySelector('body').style.removeProperty('height');
      }
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventReveal) {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

         requestAnimationFrame(this.hide.bind(this));
        } else {
          requestAnimationFrame(this.reveal.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky'); //shopify-section-header-hidden
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      let ua = navigator.userAgent;
      // console.log(!(ua.match(/Safari/) && (!ua.match(/Chrome/) || !ua.match(/Chromium/))));
      if(!(ua.match(/Safari/) && (!ua.match(/Chrome/) || !ua.match(/Chromium/)))) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
      }
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      let ua = navigator.userAgent;
      // console.log(!(ua.match(/Safari/) && (!ua.match(/Chrome/) || !ua.match(/Chromium/))));
      if(!(ua.match(/Safari/) && (!ua.match(/Chrome/) || !ua.match(/Chromium/)))) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how_knesko"] && !window.DesignMode) return;
  try {
    
  // Check if $jq is already defined before declaring it
  if (typeof $jq === 'undefined') {
    var $jq = jQuery.noConflict();
  }

  $jq(document).ready(function () {
    const prev = document.querySelector('.how_i_knesko__wrapper .custom__arrow-left');
    const next = document.querySelector('.how_i_knesko__wrapper .custom__arrow-right');

    prev.addEventListener('click', () => {
      const instaPrev = document.querySelector('.instafeed-new-arrow-prev');

      if (instaPrev) instaPrev.click();
    });

    next.addEventListener('click', () => {
      const instaNext = document.querySelector('.instafeed-new-arrow-next');

      if (instaNext) instaNext.click();
    });

    $jq('.slider__wrapper').slick({
      dots: false,
      infinite: true,
      speed: 500,
      arrows: true,
      mobileFirst: true,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      prevArrow: $jq('.custom__arrow-left'),
      nextArrow: $jq('.custom__arrow-right'),
      responsive: [
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
window.addEventListener('DOMContentLoaded',() => {
	let menu_items = document.querySelectorAll('.menu_item');
	menu_items.forEach(item => {
		if(item.firstElementChild.href.split("/").slice(3).join("/") === window.location.pathname.slice(1)){
			item.classList.add('active');
		}
	})

    $jq('.js-load-more').on('click', function(){
      var $this =$jq(this),totalPages = parseInt($jq('[data-total-pages]').val()),currentPage = parseInt($jq('[data-current-page]').val());
      $this.attr('disabled', true);
      $this.find('[load-more-text]').addClass('hide');
      $this.find('[loader]').removeClass('hide');
      var nextUrl = $jq('[data-next-url]').val().replace(/page=[0-9]+/,'page='+(currentPage + 1));
      $jq('[data-current-page]').val(currentPage + 1);
      $jq.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html',
        success: function(responseHTML){
          $jq('.blog-articles.blog-articles--collage').append($jq(responseHTML).find('.blog-articles.blog-articles--collage').html());
        },
        complete: function() {
          if(currentPage + 1 < totalPages) {
             $this.attr('disabled', false);
          } else {
          	$jq('.load-more_wrap').addClass('hidden')
          }
        }
      })
	});
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    

window.addEventListener('DOMContentLoaded',() => {

 function quickShopModalFunction() {
  let btns = []
  const closeBtns = document.querySelectorAll('.quickshop .close__btn')
  const modals = document.querySelectorAll('.quickshop.modal')

  btns = document.querySelectorAll('.quick__shop-btn')

  btns.forEach(btn => {
      btn.addEventListener("click", (e) => {
          const prodId = e.target.dataset.id
          const modal = document.querySelector(`.modal.quickshop[data-prodid="${prodId}"]`)
          const widget = modal.querySelector('.rc-container-wrapper')
  //         if (!widget) {
  //           const config = {
  //             productId: parseInt(prodId),
  //             injectionParent: '.subscription__widget', // The node that will have the widget injected in
  //             injectionMethod: 'prepend', // How will the widget be injected
  //           };
  //           window.ReChargeWidget.createWidget(config)
  //         }

            const overlay = document.createElement('div')
             overlay.classList.add('overlay')
             let overlayhide = document.getElementsByClassName('overlay')
             let overlayFather = document.querySelector('.tdf_theme_1')

            if (overlayFather.classList.contains('remove_overlayz')) {
              overlayFather.classList.remove('remove_overlayz')
            }

          overlay.addEventListener("click", () => {
  //              const scrollY = document.body.style.top;
  //              document.body.style.position = '';
  //              document.body.style.top = '';
  //              window.scrollTo(0, parseInt(scrollY || '0') * -1);
              document.documentElement.style.overflowY = "unset"
              document.querySelector(`.modal.quickshop[data-prodid="${prodId}"]`).classList.add('hidden')
              overlay.remove()
              overlayFather.classList.add('remove_overlayz')
          })
          document.body.appendChild(overlay)
          document.documentElement.style.overflowY = "hidden"
  //           document.body.style.position = 'fixed';
  //           document.body.style.top = `-${window.scrollY}px`;
          modal.classList.remove('hidden')
      })
  })

  var labels = document.querySelectorAll('.inside-modal label')
  labels.forEach(label => {
      label.addEventListener('click', () => {
          var labelText = label.innerHTML;
          var Regprices = document.querySelectorAll('.quickshop:not(.hidden) .price-item--regular');

          //setTimeout(function(){ Regprices.forEach(Regprice => {  Regprice.classList.add("hidden_regular_price");  }); },1000);
          //console.log(labelText);
              if(labelText.indexOf('Single')>= 0 ){
                  if(document.querySelector('.quickshop:not(.hidden) .rc-container-wrapper')){
                      document.querySelector('.quickshop:not(.hidden) .rc-container-wrapper').style.display='none';

                  }

              }else{
              var prodId = label.getAttribute('for');
              var myArray = prodId.split("-");
              let prodIdz = myArray[0];
              console.log(prodIdz);
              var widget = document.querySelector('.quickshop:not(.hidden) .rc-container-wrapper')
              if (widget){document.querySelector('.quickshop:not(.hidden) .rc-container-wrapper').style.display='block'; return};

              //if (document.querySelector(".product-form__input input").dataset.prodid === undefined) return;
              var config = {
                  productId: parseInt(prodIdz),
                  injectionParent: '.quickshop:not(.hidden)  .subscription__widget', // The node that will have the widget injected in
                  injectionMethod: 'prepend', // How will the widget be injected
                  selectors: {
                      price: ['.price-item--regular'], // the selectors that will be updated based on subscription
                      variant: ['.inside-modal input']
                  }
              };
              window.ReChargeWidget.createWidget(config);
              setTimeout(function(){document.querySelector('.quickshop:not(.hidden) .rc-container-wrapper').style.display='block';},100);

          }
      })
  })


  closeBtns.forEach(btn => {
    btn.addEventListener("click", (e) => {
        e.target.closest('.quickshop').classList.add('hidden')
        let overlayFather = document.querySelector('.tdf_theme_1')
        overlayFather.classList.add('remove_overlayz')
        document.querySelector('.overlay').remove()
        window.history.pushState({}, null, '/')
        document.documentElement.style.overflowY = "unset"
//         const scrollY = document.body.style.top;
//         document.body.style.position = '';
//         document.body.style.top = '';
//         window.scrollTo(0, parseInt(scrollY || '0') * -1);
    })
  })

 modals.forEach(modal => {
  	const submit = modal.querySelector('.product-form__buttons button')
      submit.addEventListener('click', (e) => {
        const prod = modal.querySelector('.product__title').dataset.handle.toLowerCase().split(" ").join('-')
        const checkedOption = modal.querySelector('.quickshop.modal .product-form__input input:checked')
        jQuery.getJSON(`/products/${prod}.js`, function(product) {
          const prodVariants = product.variants

          jQuery.getJSON('/cart.js', function(cart) {
          var quantity = modal.querySelector('.quantity__input').value
          quantity = parseInt(quantity)
          var old_qty =  cart.item_count;
          var totals = quantity + old_qty
          console.log(quantity)
          console.log(totals)
          let variantId = ''
          prodVariants.forEach(variant => {
            if(checkedOption){
              if (variant.title === checkedOption.value) {
                variantId = variant.id
              }
            }else{
              variantId = product.variants[0].id
            }
          })
          console.log(variantId)
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: [ { id: variantId, quantity: quantity } ]})
          })
            .then(response => {
            	window.history.pushState({}, null, '/')
              e.target.closest('.quickshop').classList.add('hidden')
              document.documentElement.style.overflowY = "unset"
              document.querySelector('.overlay').remove()
			// Dropdown cart
				var notification = document.getElementById('cart-notification');
                var cartItem = document.querySelector(".cart_items");
                var cartNote = document.querySelector(".cart_note");
                var cartProducts = document.querySelector(".cart_items_products");
                cartNote.classList.remove('hidden');
                cartItem.classList.add('hidden');
                cartProducts.classList.add('hidden');
                notification.classList.add('animate', 'active');

              notification.classList.add('animate', 'active');
              notification.addEventListener('transitionend', () => {
                notification.focus();
                trapFocus(notification);
              }, { once: true });
              return response.json();
            })
            .then(response => {
              if (old_qty <= 0){
                document.getElementById('cart-icon-bubble').innerHTML += '<div class="cart-count-bubble"><span aria-hidden="true" class="cart_qty_value">'+ totals  +'</span></div>';
              }else{
                document.getElementsByClassName('cart_qty_value')[0].innerText = totals;
              }

            })
            .catch((error) => {
              console.error('Error:', error);
            })


  		});
      });

  	});
  });

}

	// let menu_items = document.querySelectorAll('.menu_item');
	// menu_items.forEach(item => {
	// 	if(item.firstElementChild.href.split("/").slice(3).join("/") === window.location.pathname.slice(1)){
	// 		item.classList.add('active');
	// 	}
	// });

	$jq('.js-load-more').on('click', function(){
		var $this =$jq(this),totalPages = parseInt($jq('[data-total-pages]').val()),currentPage = parseInt($jq('[data-current-page]').val());
		$this.attr('disabled', true);
		$this.find('[load-more-text]').addClass('hide');
		$this.find('[loader]').removeClass('hide');
		var nextUrl = $jq('[data-next-url]').val().replace(/page=[0-9]+/,'page='+(currentPage + 1));
		$jq('[data-current-page]').val(currentPage + 1);
		$jq.ajax({
			url: nextUrl,
			type: 'GET',
			dataType: 'html',
			success: function(responseHTML){
				$jq('#product-grid')
					.append($jq(responseHTML)
										.find('#product-grid')
										.html()
									);
			},
			complete: function() {
				quickShopModalFunction();
				blurry();
				console.log( 'worked' );

				if(currentPage + 1 < totalPages) {
					 $this.attr('disabled', false);
				} else {
					$jq('.load-more_wrap').addClass('hidden')
				}
			}
		});

	});
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    




class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            // if ( (html.querySelector('.grid__item'))&&($jq(window).width() < 426) ) {
            //   this.classList.add('product-recommendations--loaded');
            //   $jq('.recommendations__grid').slick({
            //   dots: true,
            //   infinite: true,
            //   speed: 500,
            //   centerMode: true,
            //   slidesToShow: 1,
            //   variableWidth: false,
            //   prevArrow: $jq('.custom__arrow-left'),
            //   nextArrow: $jq('.custom__arrow-right'),
            //   customPaging : function(slider, i) {
            //   return '<div class="recommendations-slide-dot">&nbsp;</div>';
            //   },
            //   mobileFirst: true,
            //   responsive: [
            //   {
            //   breakpoint: 500,
            //   settings: {
            //   slidesToShow: 1
            //   }
            //   },
            //   {
            //   breakpoint: 750,
            //   settings: "unslick"
            //   }
            //   ]
            //   });
            // }

            this.interval = setInterval(() => {
              if(!yotpo) return;

              yotpo.initWidgets();
              clearInterval(this.interval);
            }, 50);
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})

  } catch(e) { console.error(e); }
})();
})();
